import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './AdSenseWidget.css';

/**
 * AdSenseWidget - Google AdSense表示コンポーネント
 * プラン別に表示制御
 */
const AdSenseWidget = ({ config, location }) => {
  const { user } = useAuth();

  useEffect(() => {
    // AdSenseスクリプトが既に読み込まれているか確認
    if (config?.enabled && config?.clientId) {
      // スクリプトタグが存在しない場合のみ追加
      const existingScript = document.querySelector(`script[src*="adsbygoogle.js"]`);

      if (!existingScript) {
        const script = document.createElement('script');
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${config.clientId}`;
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);
      }

      // 広告を初期化
      try {
        if (window.adsbygoogle) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (e) {
        console.error('AdSense初期化エラー:', e);
      }
    }
  }, [config]);

  // 設定が無効な場合は表示しない
  if (!config?.enabled) {
    return null;
  }

  // クライアントIDまたはスロットIDが未設定の場合は表示しない
  if (!config?.clientId || !config?.slotId) {
    return null;
  }

  // ユーザーのプランを取得（ログインしていない場合はfree扱い）
  const userPlan = user?.plan || 'free';

  // 表示対象プランでない場合は表示しない
  const showForPlans = config?.showForPlans || ['free'];
  if (!showForPlans.includes(userPlan)) {
    return null;
  }

  return (
    <div className="adsense-widget" data-location={location}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={config.clientId}
        data-ad-slot={config.slotId}
        data-ad-format={config.adFormat || 'auto'}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSenseWidget;
